// src/components/Navbar.jsx
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const location = useLocation();
  const isRegister = location.pathname.startsWith('/r');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(prev => !prev);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className="navbar-xolo sticky-top" style={{ backgroundColor: 'rgba(10, 10, 15, 0.92)', backdropFilter: 'blur(12px)', borderBottom: '1px solid rgba(220, 38, 38, 0.25)' }}>
      <div className="container py-2 py-md-3">
        <div className="d-flex align-items-center justify-content-between">
          {/* Logo Oficial Horizontal de XOLO FEST 2026 */}
          <Link to="/" onClick={closeMobileMenu} className="text-decoration-none d-flex align-items-center">
            <img
              src="/img/brand/logo-xolofest-horizontal.png"
              alt="XOLO FEST 2026 - Club Tijuana Xoloitzcuintles"
              className="brand-nav-logo"
              style={{ maxHeight: '42px', width: 'auto', objectFit: 'contain' }}
            />
          </Link>

          {/* Menú Desktop (Sin Experiencias, Galería ni Sorteo) */}
          <div className="d-none d-lg-flex align-items-center gap-3">
            {/* Enlaces institucionales oficiales */}
            <a
              href="https://xolos.com.mx"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link-custom text-white text-decoration-none fw-semibold px-2 py-1"
              title="Sitio Oficial Club Tijuana Xoloitzcuintles"
            >
              Xolos.com.mx
            </a>
            <a
              href="https://xoloshop.com"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link-custom text-danger text-decoration-none fw-bold px-2 py-1 d-flex align-items-center gap-1"
              title="Tienda Oficial XoloShop"
            >
              <i className="bi bi-bag-fill"></i>
              <span>XoloShop</span>
            </a>

            {/* Redes Sociales Oficiales */}
            <div className="d-flex align-items-center gap-2 border-start border-secondary ps-3 ms-1">
              <a
                href="https://www.facebook.com/xoloitzcuintles/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white text-opacity-75 hover-text-white fs-5 px-1 transition"
                aria-label="Facebook Oficial Club Tijuana Xolos"
                title="Facebook"
              >
                <i className="bi bi-facebook"></i>
              </a>
              <a
                href="https://www.instagram.com/xolos/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white text-opacity-75 hover-text-white fs-5 px-1 transition"
                aria-label="Instagram Oficial Club Tijuana Xolos"
                title="Instagram"
              >
                <i className="bi bi-instagram"></i>
              </a>
              <a
                href="https://www.tiktok.com/@xolos"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white text-opacity-75 hover-text-white fs-5 px-1 transition"
                aria-label="TikTok Oficial Club Tijuana Xolos"
                title="TikTok"
              >
                <i className="bi bi-tiktok"></i>
              </a>
            </div>

            {/* Botón CTA Registrar Boleto */}
            {!isRegister && (
              <Link to="/r" className="btn btn-xolo-primary btn-sm px-3 py-2 ms-2 fw-bold text-uppercase letter-spacing-sm">
                <i className="bi bi-ticket-perforated-fill me-1"></i> Registrar Boleto
              </Link>
            )}
          </div>

          {/* Menú Móvil: Botón Registrar Boleto + Botón Hamburguesa */}
          <div className="d-flex d-lg-none align-items-center gap-2">
            {!isRegister && (
              <Link to="/r" onClick={closeMobileMenu} className="btn btn-xolo-primary btn-sm px-2 py-1 fs-7 fw-bold">
                <i className="bi bi-ticket-perforated-fill me-1"></i> Registrar
              </Link>
            )}
            <button
              type="button"
              className="btn btn-outline-danger btn-sm p-1 px-2 text-white border-secondary"
              onClick={toggleMobileMenu}
              aria-label="Abrir menú de navegación"
              aria-expanded={isMobileMenuOpen}
            >
              <i className={`bi ${isMobileMenuOpen ? 'bi-x-lg text-danger' : 'bi-list fs-5'}`}></i>
            </button>
          </div>
        </div>

        {/* Desplegable Móvil */}
        {isMobileMenuOpen && (
          <div className="d-lg-none pt-3 pb-2 mt-2 border-top border-dark animate-fade-in">
            <div className="d-flex flex-column gap-2">
              <a
                href="https://xolos.com.mx"
                target="_blank"
                rel="noopener noreferrer"
                onClick={closeMobileMenu}
                className="text-white text-decoration-none py-2 px-3 rounded bg-dark bg-opacity-50 fw-semibold d-flex align-items-center justify-content-between"
              >
                <span>Xolos.com.mx</span>
                <i className="bi bi-box-arrow-up-right text-muted small"></i>
              </a>
              <a
                href="https://xoloshop.com"
                target="_blank"
                rel="noopener noreferrer"
                onClick={closeMobileMenu}
                className="text-white text-decoration-none py-2 px-3 rounded bg-dark bg-opacity-50 fw-bold text-danger d-flex align-items-center justify-content-between"
              >
                <span><i className="bi bi-bag-fill me-2 text-danger"></i>XoloShop (Tienda Oficial)</span>
                <i className="bi bi-box-arrow-up-right text-danger small"></i>
              </a>
              
              {/* Redes Sociales en Móvil */}
              <div className="d-flex align-items-center justify-content-around py-2 px-3 mt-1 bg-black rounded border border-danger border-opacity-25">
                <span className="text-muted small fw-semibold">Síguenos:</span>
                <a
                  href="https://www.facebook.com/xoloitzcuintles/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white fs-4 px-2"
                  aria-label="Facebook"
                >
                  <i className="bi bi-facebook"></i>
                </a>
                <a
                  href="https://www.instagram.com/xolos/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white fs-4 px-2"
                  aria-label="Instagram"
                >
                  <i className="bi bi-instagram"></i>
                </a>
                <a
                  href="https://www.tiktok.com/@xolos"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white fs-4 px-2"
                  aria-label="TikTok"
                >
                  <i className="bi bi-tiktok"></i>
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
